import { render } from "./apply.vue?vue&type=template&id=5570d7e0&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"

import "./apply.vue?vue&type=style&index=0&id=5570d7e0&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5570d7e0"]])

export default __exports__